import Vue from 'vue';

export const purchaseOrdersListingService = {
  async retrievePurchaseOrders(filters, sortOrder, paginationParameters, searchParam) {
    return Vue.axios
      .get('/purchase-orders/list', {
        params: {
          ...filters,
          ...sortOrder,
          ...paginationParameters,
          searchParam
        }
      })
      .then(response => response.data);
  },

  async retrieveFilteredRecordCount(filters, searchParam) {
    return Vue.axios
      .get('/purchase-orders/count-records', {
        params: {
          ...filters,
          searchParam
        }
      })
      .then(response => response.data);
  }
};
